module.exports = __webpack_public_path__ + "img/52st.241ff236.png";